import React from 'react'
import moment from 'moment'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'
import { View, Text } from '@react-pdf/renderer'

const History = ({epcr}) => (
    <RecordSection title="History">
    <InfoLine
      label="Presenting Complaint"
      value={epcr.history.presentingComplaint.join(', ')}
    />
    <InfoLine
      label="History"
      value={epcr.history.historyPresentingComplaint}
    />
    </RecordSection>
)

export default History